import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"

interface ExpandedCellProps {
  isExpanded: boolean
}

export const ExpandedTeamInfo = styled.div`
  padding: ${({theme}) => `${theme.spacing.two} ${theme.spacing.four}`};
  background-color: ${({theme}) => theme.colors.primary1_50};
`

export const ExpandedCell = styled(Body)<ExpandedCellProps>`
  height: 100%;
  padding: 20px 40px 20px ${({theme}) => theme.spacing.four};
  ${({isExpanded, theme}) => isExpanded && `background-color: ${theme.colors.primary1_50};`}
`

export const RightAlignedHeader = styled.div`
  text-align: right;
`
